import { useState } from "react";
import axiosClient from "axios-client";
import { Link } from "react-router-dom";
import ModalHorizon from "components/modal";
import ErrorMessage from "components/ErrorMessage";
import InputField from "components/fields/InputField";
import DisclosureCard from "components/DisclosureCard";
import { faPen } from "@fortawesome/pro-solid-svg-icons";
import { isValidIP, isValidMacAddress } from "utils/validation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const CODE_TYPES = Object.freeze({
    IP: "ip",
    MAC: "mac",
});

const SecondCardSx = ({ state, setRefetchIndex }) => {
    const currentIP = state?.ip_addresses[0];
    const currentMAC = state?.mac_addresses;

    const [modal, setModal] = useState(false);
    const [confirmModal, setConfirmModal] = useState(false);
    const [message, setMessage] = useState({});

    const [modalType, setModalType] = useState();
    const [modalConfirmed, setModalConfirmed] = useState();

    const [ipAddressInModal, setIpAddressInModal] = useState(currentIP);

    const [mac0AddressInModal, setMac0AddressInModal] = useState(
        currentMAC?.eth0
    );
    const [mac1AddressInModal, setMac1AddressInModal] = useState(
        currentMAC?.eth1
    );
    const [mac2AddressInModal, setMac2AddressInModal] = useState(
        currentMAC?.eth2
    );
    const [mac3AddressInModal, setMac3AddressInModal] = useState(
        currentMAC?.eth3
    );
    const [mac4AddressInModal, setMac4AddressInModal] = useState(
        currentMAC?.eth4
    );

    let reduced;
    if (state?.mac_addresses) {
        reduced = Object.keys(state.mac_addresses).reduce((acc, current) => {
            let val = state.mac_addresses[current];
            if (val && val !== "") {
                if (acc === "") {
                    return current + ": " + val;
                } else {
                    return acc + "\n\r" + current + ": " + val;
                }
            } else {
                return acc;
            }
        }, "");
    }

    const toggleModal = () => {
        setModal((prevVal) => !prevVal);
    };

    const toggleConfirmModal = () => {
        setConfirmModal((prevVal) => !prevVal);
    };

    const resetInputs = () => {
        setIpAddressInModal(currentIP);
        setMac0AddressInModal(currentMAC?.eth0);
        setMac1AddressInModal(currentMAC?.eth1);

        setModalConfirmed(false);
    };

    const changeIpOrMac = async (type = CODE_TYPES.IP, payload) => {
        try {
            await axiosClient.put(
                `/server/${state.server.code}/change-${type}`,
                payload
            );

            return true;
        } catch (err) {
            const response = err.response;

            if (response) {
                setMessage({
                    text: response.data.message,
                    type: "ERROR",
                    errors: response.data.errors ? response.data.errors : {},
                });
            }

            return false;
        }
    };

    return (
        <>
            <DisclosureCard
                extra={"w-full p-4 sm:overflow-x-auto"}
                button={() => (
                    <div className="relative mb-6 flex items-center justify-between">
                        <div className="flex">
                            <div className="text-2xl font-bold text-gray-800 dark:text-white">
                                Dati tecnici
                            </div>
                        </div>
                        <div>
                            <img
                                src="/icon/chevron-down.svg"
                                alt="Dati server"
                                className="text-[26px] font-bold uppercase text-navy-700 dark:text-white"
                            />
                        </div>
                    </div>
                )}
                content={() => (
                    <div className="flex flex-wrap">
                        <div className="flex w-full flex-col justify-between gap-4 md:flex-row">
                            <div className="mb-6 flex flex-col gap-2 3xl:flex-row">
                                <span className="text-sm font-medium text-gray-600">
                                    Codice server:
                                </span>

                                <span className="text-sm font-medium text-gray-800">
                                    {state?.server?.code || ""}
                                </span>
                            </div>

                            <div className="mb-6 flex flex-col gap-4 lg:flex-row">
                                <div className="flex flex-col gap-2 3xl:flex-row">
                                    <span className="text-sm font-medium text-gray-600">
                                        Mac Addresses:
                                    </span>

                                    <span
                                        className="text-sm font-medium text-gray-800"
                                        style={{ whiteSpace: "pre-line" }}
                                    >
                                        {reduced || ""}
                                    </span>
                                </div>

                                {state.server.type === "virtual" && (
                                    <div>
                                        <button
                                            className="flex translate-y-[-18%] items-center gap-2 rounded-full bg-primary-500 px-3 py-1.5 text-white transition hover:opacity-[85%]"
                                            onClick={() => {
                                                resetInputs();
                                                setModalType(CODE_TYPES.MAC);
                                                toggleModal();
                                            }}
                                        >
                                            <FontAwesomeIcon
                                                className="text-[13px] "
                                                icon={faPen}
                                            />

                                            <span className="whitespace-nowrap text-sm font-semibold">
                                                Modifica MAC
                                            </span>
                                        </button>
                                    </div>
                                )}
                            </div>

                            <div className="flex flex-col gap-4 lg:flex-row">
                                <div className="flex flex-col gap-2 3xl:flex-row">
                                    <span className="text-sm font-medium text-gray-600">
                                        IP:
                                    </span>

                                    {state?.ip_addresses ? (
                                        <>
                                            {state?.ip_addresses?.map(
                                                (ip_address) => (
                                                    <span
                                                        key={ip_address}
                                                        className="text-sm font-medium text-gray-800"
                                                    >
                                                        {ip_address || ""}
                                                    </span>
                                                )
                                            )}
                                        </>
                                    ) : null}
                                </div>

                                <div>
                                    <button
                                        className="flex translate-y-[-18%] items-center gap-2 rounded-full bg-primary-500 px-3 py-1.5 text-white transition hover:opacity-[85%]"
                                        onClick={() => {
                                            resetInputs();
                                            setModalType(CODE_TYPES.IP);
                                            toggleModal();
                                        }}
                                    >
                                        <FontAwesomeIcon
                                            className="text-[13px]"
                                            icon={faPen}
                                        />

                                        <span className="text-sm font-semibold">
                                            Modifica IP
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="w-full">
                            <div className="relative overflow-x-auto">
                                <table className="w-full text-left text-sm text-gray-500 rtl:text-right dark:text-gray-400">
                                    <thead className="bg-gray-50 text-xs uppercase text-gray-700 dark:bg-gray-700 dark:text-gray-400">
                                        <tr>
                                            <th
                                                scope="col"
                                                className="px-6 py-3"
                                            >
                                                Tenant
                                            </th>
                                            <th
                                                scope="col"
                                                className="hidden px-6 py-3 md:table-cell"
                                            >
                                                Data creazione
                                            </th>
                                            <th
                                                scope="col"
                                                className="px-6 py-3"
                                            >
                                                Data modifica
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {state?.domains &&
                                        Object.keys(state?.domains)?.length >
                                            0 ? (
                                            <>
                                                {Object.keys(
                                                    state?.domains
                                                )?.map((key, index) => {
                                                    let domain =
                                                        state?.domains[key];
                                                    return (
                                                        <tr
                                                            key={key}
                                                            className="border-b border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-800"
                                                        >
                                                            <th
                                                                scope="row"
                                                                className="whitespace-nowrap px-6 py-4 font-medium text-gray-900 dark:text-white"
                                                            >
                                                                <Link
                                                                    to={{
                                                                        pathname: `/my/domain/${
                                                                            domain?.name ||
                                                                            ""
                                                                        }`,
                                                                    }}
                                                                    className="hover:text-blue-500 dark:hover:text-white"
                                                                >
                                                                    {domain?.name ||
                                                                        ""}
                                                                </Link>
                                                            </th>
                                                            <td className="hidden px-6 py-4 md:table-cell">
                                                                {domain?.created_at ||
                                                                    ""}
                                                            </td>
                                                            <td className="px-6 py-4">
                                                                {domain?.updated_at ||
                                                                    ""}
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </>
                                        ) : (
                                            <tr className="border-b border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-800">
                                                <th
                                                    colSpan={3}
                                                    scope="row"
                                                    className="whitespace-nowrap px-6 py-4 font-medium text-gray-900 dark:text-white"
                                                >
                                                    Nessun tenant presente
                                                </th>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                )}
            />

            {/* IP/MAC address change */}
            <ModalHorizon
                title={
                    modalType === CODE_TYPES.IP
                        ? "Cambio indirizzo IP"
                        : "Cambio indirizzo MAC"
                }
                isOpen={modal}
                onClose={toggleModal}
                onClickBtn={() => {
                    toggleModal();
                    toggleConfirmModal();
                }}
                btnLabel="Procedi"
                getIsBtnDisabled={() => {
                    if (modalType === CODE_TYPES.IP) {
                        return (
                            ipAddressInModal === currentIP ||
                            !isValidIP(ipAddressInModal)
                        );
                    } else {
                        return (
                            (mac0AddressInModal === currentMAC?.eth0 &&
                                mac1AddressInModal === currentMAC?.eth1 &&
                                mac2AddressInModal === currentMAC?.eth2 &&
                                mac3AddressInModal === currentMAC?.eth3 &&
                                mac4AddressInModal === currentMAC?.eth4) ||
                            !isValidMacAddress(mac0AddressInModal, true) ||
                            !isValidMacAddress(mac1AddressInModal) ||
                            !isValidMacAddress(mac2AddressInModal) ||
                            !isValidMacAddress(mac3AddressInModal) ||
                            !isValidMacAddress(mac4AddressInModal)
                        );
                    }
                }}
                content={
                    <div className="flex min-w-[70vw] flex-col gap-5 md:min-w-[24rem]">
                        {/* ip */}
                        {modalType === CODE_TYPES.IP ? (
                            <InputField
                                label="Indirizzo IP"
                                type="text"
                                value={ipAddressInModal}
                                error={
                                    !isValidIP(ipAddressInModal)
                                        ? [
                                              "Per favore inserisci un indirizzo IP valido",
                                          ]
                                        : []
                                }
                                onChange={(e) => {
                                    setIpAddressInModal(e.target.value);
                                }}
                            />
                        ) : (
                            // mac
                            <div className="flex flex-col gap-4">
                                <div>
                                    <div>Indirizzi MAC Macchina</div>

                                    <div>
                                        (compilare solo le interfacce
                                        effettivamente presenti)
                                    </div>
                                </div>

                                <div>
                                    <div>
                                        I MAC address che vi chiediamo di
                                        inserire
                                    </div>
                                    <div>
                                        sono esclusivamente quelli delle schede
                                        di rete Ethernet,
                                    </div>
                                    <div>
                                        ovvero quelli identificati come{" "}
                                        <strong>eth</strong>.
                                    </div>
                                </div>

                                <div className="flex flex-col gap-3">
                                    <InputField
                                        label="Indirizzo MAC (eth0)"
                                        type="text"
                                        value={mac0AddressInModal}
                                        error={
                                            !isValidMacAddress(
                                                mac0AddressInModal
                                            )
                                                ? [
                                                      "Per favore inserisci un indirizzo MAC valido",
                                                  ]
                                                : []
                                        }
                                        onChange={(e) => {
                                            setMac0AddressInModal(
                                                e.target.value
                                            );
                                        }}
                                    />

                                    <InputField
                                        label="Indirizzo MAC (eth1)"
                                        type="text"
                                        value={mac1AddressInModal}
                                        error={
                                            !isValidMacAddress(
                                                mac1AddressInModal
                                            )
                                                ? [
                                                      "Per favore inserisci un indirizzo MAC valido",
                                                  ]
                                                : []
                                        }
                                        onChange={(e) => {
                                            setMac1AddressInModal(
                                                e.target.value
                                            );
                                        }}
                                    />

                                    <InputField
                                        label="Indirizzo MAC (eth2)"
                                        type="text"
                                        value={mac2AddressInModal}
                                        error={
                                            !isValidMacAddress(
                                                mac2AddressInModal
                                            )
                                                ? [
                                                      "Per favore inserisci un indirizzo MAC valido",
                                                  ]
                                                : []
                                        }
                                        onChange={(e) => {
                                            setMac2AddressInModal(
                                                e.target.value
                                            );
                                        }}
                                    />

                                    <InputField
                                        label="Indirizzo MAC (eth3)"
                                        type="text"
                                        value={mac3AddressInModal}
                                        error={
                                            !isValidMacAddress(
                                                mac3AddressInModal
                                            )
                                                ? [
                                                      "Per favore inserisci un indirizzo MAC valido",
                                                  ]
                                                : []
                                        }
                                        onChange={(e) => {
                                            setMac3AddressInModal(
                                                e.target.value
                                            );
                                        }}
                                    />

                                    <InputField
                                        label="Indirizzo MAC (eth4)"
                                        type="text"
                                        value={mac4AddressInModal}
                                        error={
                                            !isValidMacAddress(
                                                mac4AddressInModal
                                            )
                                                ? [
                                                      "Per favore inserisci un indirizzo MAC valido",
                                                  ]
                                                : []
                                        }
                                        onChange={(e) => {
                                            setMac4AddressInModal(
                                                e.target.value
                                            );
                                        }}
                                    />
                                </div>
                            </div>
                        )}

                        <ErrorMessage message={message} />
                    </div>
                }
            />

            <ModalHorizon
                title={
                    modalType === CODE_TYPES.IP
                        ? "Conferma cambio indirizzo IP"
                        : "Conferma cambio indirizzo MAC"
                }
                isOpen={confirmModal}
                onClose={toggleConfirmModal}
                onClickBtn={async () => {
                    let payload;

                    if (modalType === CODE_TYPES.IP) {
                        payload = { ip: ipAddressInModal };
                    } else {
                        payload = {
                            mac: {
                                eth0: mac0AddressInModal,
                                eth1: mac1AddressInModal,
                            },
                        };
                    }

                    const isSuccessful = await changeIpOrMac(
                        modalType === CODE_TYPES.IP
                            ? CODE_TYPES.IP
                            : CODE_TYPES.MAC,
                        payload
                    );

                    if (isSuccessful) {
                        toggleConfirmModal();
                        setRefetchIndex((prev) => prev + 1);
                    }
                }}
                btnLabel={
                    modalType === CODE_TYPES.IP ? "Cambia IP" : "Cambia MAC"
                }
                btnDisabled={!modalConfirmed}
                content={
                    <div className="flex flex-col gap-6">
                        <div className="flex flex-col gap-5">
                            <div>
                                <div className="font-semibold">
                                    Sei sicuro di voler procedere?
                                </div>
                                <div className="text-[14px]">
                                    Le modifiche verranno applicate entro un
                                    massimo di 10 minuti.
                                </div>
                            </div>

                            <div className="flex flex-col items-center gap-2 md:flex-row md:gap-5">
                                {modalType === CODE_TYPES.IP ? (
                                    <div className="flex flex-col">
                                        <span className="text-[12px]">
                                            Vecchio IP
                                        </span>
                                        <span className="font-semibold">
                                            {currentIP}
                                        </span>
                                    </div>
                                ) : (
                                    <div className="flex flex-col gap-3">
                                        {currentMAC?.eth0 !==
                                            mac0AddressInModal && (
                                            <div className="flex min-h-[2.65rem] flex-col">
                                                <span className="text-[12px]">
                                                    Vecchio MAC (eth0)
                                                </span>
                                                <span className="font-semibold">
                                                    {currentMAC?.eth0 ?? ""}
                                                </span>
                                            </div>
                                        )}

                                        {currentMAC?.eth1 !==
                                            mac1AddressInModal && (
                                            <div className="flex min-h-[2.65rem] flex-col">
                                                <span className="text-[12px]">
                                                    Vecchio MAC (eth1)
                                                </span>
                                                <span className="font-semibold">
                                                    {currentMAC?.eth1 ?? ""}
                                                </span>
                                            </div>
                                        )}

                                        {currentMAC?.eth2 !==
                                            mac2AddressInModal && (
                                            <div className="flex min-h-[2.65rem] flex-col">
                                                <span className="text-[12px]">
                                                    Vecchio MAC (eth2)
                                                </span>
                                                <span className="font-semibold">
                                                    {currentMAC?.eth2 ?? ""}
                                                </span>
                                            </div>
                                        )}

                                        {currentMAC?.eth3 !==
                                            mac3AddressInModal && (
                                            <div className="flex min-h-[2.65rem] flex-col">
                                                <span className="text-[12px]">
                                                    Vecchio MAC (eth3)
                                                </span>
                                                <span className="font-semibold">
                                                    {currentMAC?.eth3 ?? ""}
                                                </span>
                                            </div>
                                        )}

                                        {currentMAC?.eth4 !==
                                            mac4AddressInModal && (
                                            <div className="flex min-h-[2.65rem] flex-col">
                                                <span className="text-[12px]">
                                                    Vecchio MAC (eth4)
                                                </span>
                                                <span className="font-semibold">
                                                    {currentMAC?.eth4 ?? ""}
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                )}

                                <span>→</span>

                                {modalType === CODE_TYPES.IP ? (
                                    <div className="flex flex-col">
                                        <span className="text-[12px]">
                                            Nuovo IP
                                        </span>
                                        <span className="font-semibold">
                                            {ipAddressInModal}
                                        </span>
                                    </div>
                                ) : (
                                    <div className="flex flex-col gap-3">
                                        {currentMAC?.eth0 !==
                                            mac0AddressInModal && (
                                            <div className="flex min-h-[2.65rem] flex-col">
                                                <span className="text-[12px]">
                                                    Nuovo MAC (eth0)
                                                </span>
                                                <span className="font-semibold">
                                                    {mac0AddressInModal}
                                                </span>
                                            </div>
                                        )}

                                        {currentMAC?.eth1 !==
                                            mac1AddressInModal && (
                                            <div className="flex min-h-[2.65rem] flex-col">
                                                <span className="text-[12px]">
                                                    Nuovo MAC (eth1)
                                                </span>
                                                <span className="font-semibold">
                                                    {mac1AddressInModal}
                                                </span>
                                            </div>
                                        )}

                                        {currentMAC?.eth2 !==
                                            mac2AddressInModal && (
                                            <div className="flex min-h-[2.65rem] flex-col">
                                                <span className="text-[12px]">
                                                    Nuovo MAC (eth2)
                                                </span>
                                                <span className="font-semibold">
                                                    {mac2AddressInModal}
                                                </span>
                                            </div>
                                        )}

                                        {currentMAC?.eth3 !==
                                            mac3AddressInModal && (
                                            <div className="flex min-h-[2.65rem] flex-col">
                                                <span className="text-[12px]">
                                                    Nuovo MAC (eth3)
                                                </span>
                                                <span className="font-semibold">
                                                    {mac3AddressInModal}
                                                </span>
                                            </div>
                                        )}

                                        {currentMAC?.eth4 !==
                                            mac4AddressInModal && (
                                            <div className="flex min-h-[2.65rem] flex-col">
                                                <span className="text-[12px]">
                                                    Nuovo MAC (eth4)
                                                </span>
                                                <span className="font-semibold">
                                                    {mac4AddressInModal}
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="flex items-center gap-3">
                            <input
                                type="checkbox"
                                id="confirm-change"
                                className="h-4 w-4 cursor-pointer accent-brand-500"
                                checked={modalConfirmed}
                                onChange={(e) =>
                                    setModalConfirmed(e.target.checked)
                                }
                            />
                            <label
                                htmlFor="confirm-change"
                                className="cursor-pointer select-none text-sm text-gray-700/90 transition hover:text-gray-800/90"
                            >
                                {modalType === CODE_TYPES.IP
                                    ? "Ho verificato il nuovo indirizzo e confermo che è corretto."
                                    : "Ho verificato i nuovi indirizzi e confermo che sono corretti."}
                            </label>
                        </div>
                    </div>
                }
            />
        </>
    );
};

export default SecondCardSx;
